import { render, staticRenderFns } from "./TechTreeAge.vue?vue&type=template&id=e88aa3e8&scoped=true&"
import script from "./TechTreeAge.vue?vue&type=script&lang=js&"
export * from "./TechTreeAge.vue?vue&type=script&lang=js&"
import style0 from "./TechTreeAge.vue?vue&type=style&index=0&id=e88aa3e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88aa3e8",
  null
  
)

export default component.exports